import {Component} from 'react';
import {SubmissionError} from 'redux-form';
import {translateAPIResponse} from '../../utils/form';
import LocalizedStrings from '../../localization/strings';

export default class BaseForm extends Component {
    showAlert() {
        return true;
    }
    submit(values) {
        const {onSuccessSubmit, submit} = this.props;
        const hadId = !values.id;
        return submit(values).then(translateAPIResponse).then((result) => {
            if (this.showAlert()) {
                alert('Saved');
            }
            if (onSuccessSubmit) {
                onSuccessSubmit(hadId, result.payload);
            }
        }).catch((errors) => {
            if (errors instanceof SubmissionError) throw errors;
            const message = (errors && typeof errors === 'object' && !Array.isArray(errors))
                ? Object.values(errors).join(', ')
                : LocalizedStrings.genericError;
            throw new SubmissionError({ _error: message });
        });
    }

    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/js/components/form/base-form.js